module.exports = __webpack_public_path__ + "img/127.3a84ecc5.jpg";